export default __webpack_public_path__ + "media/images/raty/star-half-2-1fe4cd87f1f323a45548609343c1aa1a.png";